// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.breakdown-table .toggle[data-v-3054b4fe] {
  cursor: pointer;
}
.breakdown-table .legend[data-v-3054b4fe] {
  height: 10px;
  width: 10px;
  display: inline-block;
}
.breakdown-table tr:first-child td[data-v-3054b4fe] {
  border-top: none;
}
.breakdown-table tr[data-v-3054b4fe]:last-child {
  border-bottom: 1pt solid #dddddd;
}
.breakdown-table tr td[data-v-3054b4fe] {
  padding: 0px 3px 0px 3px;
}
.breakdown-table tr td[data-v-3054b4fe]:nth-of-type(1) {
  vertical-align: top;
  width: 20px;
  height: 20px;
}
.breakdown-table tr td[data-v-3054b4fe]:nth-of-type(2) {
  color: #333333;
  font-size: 14px;
  font-family: "AvenirNextLTW01-Regular", Arial;
}
.breakdown-table tr td:nth-of-type(2) span[data-v-3054b4fe]:nth-of-type(2) {
  float: right;
  font-family: "Avenir Next LT W01 Demi", Arial;
}
.breakdown-table tr td table.sub-table tr td[data-v-3054b4fe] {
  width: 100%;
}
.breakdown-table tr td table.sub-table tr td[data-v-3054b4fe]:nth-of-type(2) {
  float: right;
  font-family: "Avenir Next LT W01 Demi", Arial;
}
`, "",{"version":3,"sources":["webpack://./src/components/global/BreakdownTable.vue","webpack://./BreakdownTable.vue"],"names":[],"mappings":"AACA;EAEE,eAAA;ACDF;ADDA;EAKE,YAAA;EACA,WAAA;EACA,qBAAA;ACDF;ADIE;EAEE,gBAAA;ACHJ;ADME;EACC,gCAAA;ACJH;ADZA;EAmBG,wBAAA;ACJH;ADKG;EACC,mBAAA;EACA,WAAA;EACA,YAAA;ACHJ;ADKG;EACC,cAAA;EACA,eAAA;EACA,6CAAA;ACHJ;ADAG;EAKE,YAAA;EACA,6CAAA;ACFL;AD7BA;EAmCI,WAAA;ACHJ;ADKI;EACC,YAAA;EACA,6CAAA;ACHL","sourcesContent":["\n.breakdown-table {\n\t.toggle {\n\t\tcursor: pointer;\n\t}\n\t.legend {\n\t\theight: 10px;\n\t\twidth: 10px;\n\t\tdisplay: inline-block;\n\t}\n\ttr {\n\t\t&:first-child {\n\t\t\ttd {\n\t\t\t\tborder-top: none;\n\t\t\t}\n\t\t}\n\t\t&:last-child{\n\t\t\tborder-bottom:1pt solid #dddddd;\n\t\t}\n\t\ttd {\n\t\t\tpadding: 0px 3px 0px 3px;\n\t\t\t&:nth-of-type(1) {\n\t\t\t\tvertical-align: top;\n\t\t\t\twidth: 20px;\n\t\t\t\theight: 20px;\n\t\t\t}\n\t\t\t&:nth-of-type(2) {\n\t\t\t\tcolor: #333333;\n\t\t\t\tfont-size: 14px;\n\t\t\t\tfont-family: \"AvenirNextLTW01-Regular\",Arial;\n\t\t\t\tspan:nth-of-type(2) {\n\t\t\t\t\tfloat: right;\n\t\t\t\t\tfont-family:\"Avenir Next LT W01 Demi\", Arial;\n\t\t\t\t}\n\t\t\t}\n\t\t\ttable.sub-table tr td {\n\t\t\t\twidth: 100%;\n\n\t\t\t\t&:nth-of-type(2){\n\t\t\t\t\tfloat: right;\n\t\t\t\t\tfont-family:\"Avenir Next LT W01 Demi\", Arial;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n",".breakdown-table .toggle {\n  cursor: pointer;\n}\n.breakdown-table .legend {\n  height: 10px;\n  width: 10px;\n  display: inline-block;\n}\n.breakdown-table tr:first-child td {\n  border-top: none;\n}\n.breakdown-table tr:last-child {\n  border-bottom: 1pt solid #dddddd;\n}\n.breakdown-table tr td {\n  padding: 0px 3px 0px 3px;\n}\n.breakdown-table tr td:nth-of-type(1) {\n  vertical-align: top;\n  width: 20px;\n  height: 20px;\n}\n.breakdown-table tr td:nth-of-type(2) {\n  color: #333333;\n  font-size: 14px;\n  font-family: \"AvenirNextLTW01-Regular\", Arial;\n}\n.breakdown-table tr td:nth-of-type(2) span:nth-of-type(2) {\n  float: right;\n  font-family: \"Avenir Next LT W01 Demi\", Arial;\n}\n.breakdown-table tr td table.sub-table tr td {\n  width: 100%;\n}\n.breakdown-table tr td table.sub-table tr td:nth-of-type(2) {\n  float: right;\n  font-family: \"Avenir Next LT W01 Demi\", Arial;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
